export enum MenuItemsIdsEnum {
  KNM_INFO = 'KNM_INFO',
  KNM_REQUIREMENTS = 'KNM_REQUIREMENTS',
  KNM_CHECK_SHEETS = 'KNM_CHECK_SHEETS',
  KNM_APPROVE_INFO = 'KNM_APPROVE_INFO',
  KNM_CONTROL_AGENCY = 'KNM_CONTROL_AGENCY',
  KNM_VERIFIED_PERSON = 'KNM_VERIFIED_PERSON',
  KNM_NOTICE_INFO = 'KNM_NOTICE_INFO',
  KNM_RESULTS = 'KNM_RESULTS',
  KNM_VIOLATIONS_LIST = 'KNM_VIOLATIONS_LIST',
  KNM_LAWSUITS = 'KNM_LAWSUITS',
  KNM_CANCELLATION_INFO = 'KNM_CANCELLATION_INFO',
  KNM_SIGN_INFO = 'KNM_SIGN_INFO',
  KNM_DOCUMENTS = 'KNM_DOCUMENTS',
  KNM_PREVIOUS = 'KNM_PREVIOUS',
  KNM_LINKS = 'KNM_LINKS',
  KNM_HISTORY = 'KNM_HISTORY',
  KNM_EXECUTION_HISTORY = 'KNM_EXECUTION_HISTORY',
}
